var map = {
	"./alert-triangle.svg": 569,
	"./calendar-blue.svg": 797,
	"./calendar-check.svg": 719,
	"./calendar.svg": 996,
	"./check.svg": 814,
	"./checkmark-icon.svg": 829,
	"./chevron-black-down.svg": 718,
	"./chevron-down.svg": 116,
	"./chevron-thick-black.svg": 577,
	"./exclamation.svg": 537,
	"./exit.svg": 710,
	"./file-plus.svg": 277,
	"./get-help.svg": 2,
	"./icon-book.svg": 953,
	"./icon-calender.svg": 900,
	"./icon-vaccine.svg": 983,
	"./icons.svg": 260,
	"./logo-footer.svg": 745,
	"./map-pin.svg": 574,
	"./phone.svg": 433,
	"./red-alert-triangle.svg": 415,
	"./red-check.svg": 404,
	"./search.svg": 926,
	"./travel.svg": 34,
	"./user.svg": 695,
	"./x-circle.svg": 615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;